import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiBaseUrl } from 'utils/user';
import { FeatureFlags, FeatureId } from './catalog';

export const apiFeatures = createApi({
  reducerPath: 'featuresApi',
  tagTypes: ['Features'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${getApiBaseUrl()}/`,
    credentials: 'include',
    prepareHeaders: (headers) => {
      headers.set('X-Client', 'web');
      return headers;
    },
  }),
  endpoints: builder => ({
    getFeatures: builder.query<FeatureFlags, void>({
      query: () => 'features',
      transformResponse: (data: { features: FeatureFlags }) => data.features,
      transformErrorResponse: (response: { status: string | number }) => response.status,
      providesTags: ['Features'],
    }),
    patchFeatures: builder.mutation<FeatureFlags, Partial<Record<FeatureId, boolean>>>({
      query: body => ({
        url: 'features',
        method: 'PATCH',
        body,
      }),
      transformResponse: (data: { features: FeatureFlags }) => data.features,
      async onQueryStarted(patch, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          apiFeatures.util.updateQueryData('getFeatures', undefined, draft => {
            Object.assign(draft, patch);
          }),
        );
        try {
          const { data } = await queryFulfilled;
          dispatch(
            apiFeatures.util.updateQueryData('getFeatures', undefined, () => data),
          );
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetFeaturesQuery,
  usePatchFeaturesMutation,
} = apiFeatures;
